import React from 'react';
import img from '../images/about-shoes.JPG';

const Intro = () => {
    return (
        <div className="bg-white py-20 px-4" id="about">
            <div className="max-w-6xl mx-auto">
                <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20" data-aos="fade-up">

                    {/* Image */}
                    <div className="w-full lg:w-1/2" data-aos="zoom-in" data-aos-delay="200">
                        <div className="rounded-2xl overflow-hidden shadow-xl">
                            <img
                                alt="Saving Strides shoe collection"
                                className="w-full h-auto object-cover"
                                src={img}
                            />
                        </div>
                    </div>

                    {/* Text */}
                    <div className="w-full lg:w-1/2 text-center lg:text-left" data-aos="fade-left" data-aos-delay="300">
                        <div className="inline-flex items-center gap-2 bg-gray-100 text-gray-600 text-sm font-medium px-4 py-1.5 rounded-full mb-5">
                            About Us
                        </div>
                        <h2 className="text-3xl md:text-4xl font-bold text-black mb-6 leading-tight">
                            Making a Difference,<br className="hidden sm:block" /> One Step at a Time
                        </h2>
                        <div className="space-y-4 text-gray-600 text-lg leading-relaxed">
                            <p>
                                At Saving Strides, our mission is to provide running shoes and other footwear to individuals and communities in need.
                            </p>
                            <p>
                                We partner with local run clubs across the GTA to collect gently used running shoes, supporting those who need them most.
                            </p>
                            <p>
                                Working together as a community for the community, we make strides toward a brighter future for everyone.
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Intro;
